import React from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import './ValidatedFail.scss';
import HeaderValidation from '../../Dashboard/Visitor/External/Components/HeaderValidation';
import {IconLogoIEntryComplete} from '../../../components/buttons/IconButtons';
import ContainerValidation from '../../Dashboard/Visitor/External/Components/ContainerValidation';
import BodyValidation from '../../Dashboard/Visitor/External/Components/BodyValidation';
import routes from '../../../Routes/routes';
import {getUrlParameters} from "../../Dashboard/Visitor/External/Model/Model";
import ValidatedFailBody from "../../Dashboard/Visitor/External/ValidatedFailBody";
import {GetInvitationById} from "../../../reduxToolkit/Invitation/InvitationApi";
import {useDispatch} from "react-redux";

const ValidatedFail = () => {
    const { id, guardFlowId } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();


    return (
        <>
            <ContainerValidation>
                <HeaderValidation
                    showBtnBack={false}
                    headerCenter={<IconLogoIEntryComplete height={30} />}
                />
                <BodyValidation
                    showBtnNext={false}
                    showBtnPrev={true}
                    showLogoFooter={false}
                    className="identity-invitation-body"
                    classWith="content-center-w-800px gap-2"
                    clickPrev={() => {
                        dispatch(GetInvitationById(id)).then(({ payload :{data:{ success } }})=>{
                            if (success)  navigate(getUrlParameters({ url: routes.invitationDetails.registrationProcess, id, guardFlowId}));
                        });
                    }}
                >
                    <ValidatedFailBody title={"identity_validation_failed"}/>
                </BodyValidation>
            </ContainerValidation>

        </>
    );
};

export default ValidatedFail;
